"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgShow = function (props) {
    var color = props.color;
    return (react_1.default.createElement("path", { fill: color, fillRule: "evenodd", d: "M12 5c3.9 0 7.122 1.972 9.666 5.916a2 2 0 0 1 0 2.168C19.122 17.028 15.9 19 12 19c-3.893 0-7.11-1.92-9.653-5.758a2 2 0 0 1-.025-2.168C4.868 7.024 8.094 5 12 5zm0 2c-3.173 0-5.785 1.64-7.985 5.138C6.203 15.443 8.814 17 12 17c3.18 0 5.791-1.598 7.985-5C17.791 8.598 15.18 7 12 7zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" }));
};
exports.default = factorySvgIcon_1.default(SvgShow);
//# sourceMappingURL=SvgShow.js.map